import React from 'react'
import { RiDeleteBin5Line } from 'react-icons/ri'
import moment from 'moment'

const Row = ({stat, index, setSelectedId}) => {
  
  const difdate = stat?.endedAt !== '' && ((stat?.endedAt.toDate().getTime() - stat?.startedAt.toDate().getTime())) / 1000

  return (
    <tr className="bg-white border-b  dark:border-gray-300 text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-50">
     <td className="px-2 py-3 font-semibold">
       {index+1}
     </td>
     <th scope="row" className="flex items-center px-3 py-3 font-medium text-gray-900  whitespace-nowrap">
        {stat.machineMacAdress}
     </th>
    <td className="px-6 py-3">
        {moment(stat?.startedAt.toDate()).format('LLL')}
    </td>
    <td className="px-6 py-3">
        {stat?.endedAt === '' ? '...' : moment(stat?.endedAt.toDate()).format('LLL')}
    </td>
    <td className="px-6 py-3">
        {parseInt(difdate / 60 / 60) >= 10 ? parseInt(difdate / 60 / 60) : '0' + parseInt(difdate / 60 / 60)}<span className='font-semibold mx-[2px]'>:</span>
        {parseInt(difdate / 60 % 60) >= 10 ? parseInt(difdate / 60 % 60) : '0' + parseInt(difdate / 60 % 60)}<span className='font-semibold mx-[2px]'>:</span>
        {parseInt(difdate % 60) >= 10 ? parseInt(difdate % 60) : '0' + parseInt(difdate % 60)}

    </td>
    <td className="px-6 text-right">
        <div className=" flex items-center">
            <RiDeleteBin5Line className='text-2xl ml-4 cursor-pointer text-red-500' onClick={()=> setSelectedId(stat.id)} /> 
        </div>
    </td>
</tr>
  )
}

export default Row